import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import {Stack, Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {FiAlertTriangle} from 'react-icons/fi';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  table: {
    border: 'none',
    '& th, & td': {
      border: 'none', // Remove cell borders
      padding: '12px',
    },
    '&:nth-child(1)': {
      width: '50%',
    },
    '&:nth-child(2)': {
      width: '1%',
    },
  },
  lighterCell: {
    color: '#6B7280',
    border: 0,
  },
});

const DialogDelete = ({open, onClickClose, onClickDelete, label}) => {
  const classes = useStyles();

  

  return (
    <div>
      <Dialog
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '800px !important',
            width: '750px',
            height: '285px',
            padding: '50px',
            borderRadius: '16px',
          },
        }}
      >
        <DialogContent>
          <DialogContentText>
            <Stack direction={'row'} alignItems={'center'} gap={3}>
              <FiAlertTriangle fontSize={'56px'} />
              <Stack direction={'column'} gap={3}>
                <Typography sx={{color: '#111827', fontSize: '18px'}}>
                  Hapus Aksi Perubahan?
                </Typography>
                <Typography sx={{color: '#6B7280', fontSize: '14px'}}>
                  Apakah Anda yakin akan menghapus Aksi Perubahan berikut?
                </Typography>
              </Stack>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClickClose}
            variant='contained'
            size='small'
            style={{
              width: '100px',
              backgroundColor: '#F5F5F5',
              color: '#9F9F9F',
            }}
          >
            BATAL
          </Button>
          <Button
            onClick={onClickDelete}
            variant='contained'
            size='small'
            style={{width: '100px', backgroundColor: '#800000'}}
          >
            HAPUS
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogDelete;

DialogDelete.propTypes = {
  open: PropTypes.any,
  onClickClose: PropTypes.func,
  onClickDelete: PropTypes.func,
  label: PropTypes.string,
};
